import { useEffect } from 'react'
import { useAppStore } from '../store/app'
import './Toasts.css'

// Transient banner stack rendered top-of-screen. Toasts are pushed
// via useAppStore().pushToast(text, kind?) and auto-dismiss after
// ~4s. Tap to dismiss early. Mounted once in App.tsx.
export function Toasts() {
  const toasts = useAppStore((s) => s.toasts)
  const dismiss = useAppStore((s) => s.dismissToast)

  useEffect(() => {
    if (toasts.length === 0) return
    const now = Date.now()
    const next = Math.min(...toasts.map((t) => t.expiresAt)) - now
    const handle = setTimeout(() => {
      const nowAgain = Date.now()
      for (const t of toasts) {
        if (t.expiresAt <= nowAgain) dismiss(t.id)
      }
    }, Math.max(next, 50))
    return () => clearTimeout(handle)
  }, [toasts, dismiss])

  if (toasts.length === 0) return null
  return (
    <div className="toasts">
      {toasts.map((t) => (
        <button
          key={t.id}
          className={`toasts__item toasts__item--${t.kind}`}
          onClick={() => dismiss(t.id)}
        >
          {t.text}
        </button>
      ))}
    </div>
  )
}
